import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import Layout from './components/Layout/Layout';
import Dashboard from './components/Dashboard';
import GameView from './components/Game/GameView';
import InstructionsPage from './components/Instructions/InstructionsPage';
import LeaderboardPage from './components/Leaderboard/LeaderboardPage';
import BitWheelInfo from './components/Info/BitWheelInfo';
import ResetPasswordPage from './components/Auth/ResetPasswordPage';
import { PlayerProvider } from './context/PlayerContext';
import { FreePlayProvider } from './context/FreePlayContext';
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <AuthProvider>
      <PlayerProvider>
        <FreePlayProvider>
        <BrowserRouter>
          <Routes>
            <Route path="bit-wheel" element={<BitWheelInfo />} />
            <Route path="reset-password" element={<ResetPasswordPage />} />
            <Route element={<Layout />}>
              <Route index element={<Navigate to="/game" replace />} />
              <Route path="game" element={<GameView />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="instructions" element={<InstructionsPage />} />
              <Route path="leaderboard" element={<LeaderboardPage />} />
              <Route path="*" element={<Navigate to="/game" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
        </FreePlayProvider>
      </PlayerProvider>
    </AuthProvider>
  );
}

export default App;
